<template>
  <div>
      <div>
        <vue-cal selected-date="2018-11-19"
                :time-from="9 * 60"
                :time-to="19 * 60"
                :disable-views="['years', 'year']"
                hide-weekends
        ></vue-cal>
      </div>
  </div>
</template>

<script>
  import VueCal from 'vue-cal';
  import 'vue-cal/dist/vuecal.css';

  export default {
    name: 'CalendarVue',
    components: {
      VueCal,
    },
    
  }
</script>

<style>
  .vuecal__cell-date {
    padding: 10px;
  }

  .vuecal__event {cursor: pointer;}

  .vuecal__event-title {
    font-size: 1.2em;
    font-weight: bold;
    margin: 4px 0 8px;
  }

  .vuecal__event-time {
    display: inline-block;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  .vuecal__event-content {
    font-style: italic;
  }
</style>